export const safeJsonParse = (text, reviver) => {
  if (typeof text !== 'string') {
    return null;
  }

  let result = null;
  try {
    result = JSON.parse(text, reviver);
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.info('safeJsonParse text:', text);
    console.warn(ex);
  }

  return result;
};
